import { Fragment } from 'react';
import type { AuditSegment } from 'types/api-responses';
import { entityIdSuffix } from 'utils/entity-id';

// One audit-detail bullet: plain strings render as-is, entity refs as
// "<name> (Entity ID: <id>)" links to the entity page. The single client-side
// renderer of the AuditSegment shape.
export const AuditSegments = ({ segments }: { segments: AuditSegment[] }) => (
  <>
    {segments.map((seg, i) => {
      if (typeof seg === 'string') {
        return <Fragment key={i}>{seg}</Fragment>;
      }
      return (
        <a key={i} href={`/entities/${seg.entityId}`}>
          {seg.entityName} {entityIdSuffix(seg.entityId)}
        </a>
      );
    })}
  </>
);
